import type React from 'react';

import {
  LabelField,
  UserChipField,
  OrdDatagrid,
  OrdCreateDialog,
  OrdEditDialog,
  OrdList,
  OrdIconStandard,
} from '@ragu-components/ord-components';
import { ExtensionFields } from '@ragu-components/ord-types';
import { NumberField, TextField } from 'react-admin';

import { ExtensionsBulkEditForm, ExtensionsForm } from './ExtensionsForm';

import type { OrdDatagridProps, OrdListProps } from '@ragu-components/ord-components';

interface ExtensionListProps extends Partial<Omit<OrdListProps, 'empty'>> {
  embeddedChildren?: React.ReactElement | React.ReactElement[];
  empty?: OrdDatagridProps['empty'];
}

export const ExtensionList = ({
  embeddedChildren = undefined,
  empty = undefined,
  layout = 'full',
  ...props
}: ExtensionListProps): React.ReactElement => (
  <>
    <OrdList
      icon={<OrdIconStandard name='extensions' />}
      layout={layout}
      sort={{ field: ExtensionFields.number, order: 'ASC' }}
      {...props}
    >
      <OrdDatagrid
        layout={layout}
        empty={empty}
        bulkActionButtonsBefore={<ExtensionsBulkEditForm />}
        bulkCloneButtonNameKey='number'
      >
        <TextField source={ExtensionFields.number} />
        <NumberField source={ExtensionFields.ringtime} sortable={false} />
        {layout === 'full' && <UserChipField sortable={false} source={ExtensionFields.user} />}
        <LabelField />
        {embeddedChildren}
      </OrdDatagrid>
    </OrdList>
    {layout === 'full' ? (
      <>
        <OrdCreateDialog>
          <ExtensionsForm />
        </OrdCreateDialog>
        <OrdEditDialog>
          <ExtensionsForm />
        </OrdEditDialog>
      </>
    ) : null}
  </>
);

export default ExtensionList;
